import React, { useState } from "react"
import { useQuery } from "@apollo/client"
import { useParams } from "react-router-dom"
import Header from "../components/Header"
import Card from "../components/Card"
import Create from "../components/Create"
import { NOTES } from "../graphql/Notes"
import { INote } from "../interface"
import Loading from "../components/Loading"
import SideNav from "../components/SideNav"
import useDebounce from "../hooks/useDebounce"

const Main: React.FC = () => {
  const [searchString, setSearchString] = useState<string>("")
  const [showCreate, setShowCreate] = useState<boolean>(false)
  const [navBarVisble, setNavBarVisible] = useState<boolean>(false)
  const { userId } = useParams()

  // using debounce value
  const debounceSearchString = useDebounce(searchString, 300)

  const { data, error, loading, refetch } = useQuery(NOTES, {
    variables: { userId },
  })

  if (loading) return <Loading />
  if (error) return <div>Something went wrong: {JSON.stringify(error)}</div>

  return (
    <div className='grid grid-rows-[auto_auto_1fr_auto] overflow-hidden text-white min-h-dvh md:p-6 '>
      <h1 className='p-2 font-serif text-xl text-center md:text-2xl'>Note Moko</h1>

      <Header setSearchString={setSearchString} searchString={searchString} setShowCreate={setShowCreate} isLoading={loading} refetch={refetch} setNavBar={setNavBarVisible} />

      <main className='pointer-events-auto pb-11 overscroll-auto md:mx-11 '>
        <ul className='grid h-full grid-cols-1 gap-1 m-4 overflow-auto place-content-start md:grid-cols-2 xl:grid-cols-4'>
          {data &&
            data.notes.map((note: INote) => {
              if (note.keyword.match(new RegExp(debounceSearchString, "i")) || note.title.match(new RegExp(debounceSearchString, "i")) || note.content.match(new RegExp(debounceSearchString, "i")) || note.createdAt.match(new RegExp(debounceSearchString, "i"))) {
                return <Card key={note._id} note={note} refetch={refetch} />
              }
              return null
            })}
        </ul>
      </main>

      <SideNav nav={navBarVisble} setNav={setNavBarVisible} />
      {!loading && <Create setShowCreate={setShowCreate} showCreate={showCreate} userId={userId} refetch={refetch} />}
    </div>
  )
}

export default Main
